import { render } from "./SocketNotification.vue?vue&type=template&id=3dccf8db&scoped=true"
import script from "./SocketNotification.vue?vue&type=script&lang=js"
export * from "./SocketNotification.vue?vue&type=script&lang=js"

import "./SocketNotification.vue?vue&type=style&index=0&id=3dccf8db&lang=scss&scoped=true"

import exportComponent from "/app/tmp/10eqs/V3/v2026.33.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dccf8db"]])

export default __exports__